<fieldset *ngIf="ready">
    <div class="row">
        <div class="col-md-6">
            <ng-container *ngTemplateOutlet="templateCampoTexto; context:{va:vaFontFamily}"></ng-container>
        </div>
        <div class="col-md-3">
            <ng-container *ngTemplateOutlet="templateCampoTexto; context:{va:vaFontSize}"></ng-container>
        </div>
        <div class="col-md-3">
            <ng-container *ngTemplateOutlet="templateCampoTexto; context:{va:vaColor}"></ng-container>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <ng-container *ngTemplateOutlet="templateCampoCombo; context:{va:vaTextTransform}"></ng-container>
        </div>
        <div class="col-md-3">
            <ng-container *ngTemplateOutlet="templateCampoCombo; context:{va:vaFontWeight}"></ng-container>
        </div>
        <div class="col-md-3">
            <ng-container *ngTemplateOutlet="templateCampoCombo; context:{va:vaFontStyle}"></ng-container>
        </div>
        <div class="col-md-3">
            <ng-container *ngTemplateOutlet="templateCampoCombo; context:{va:vaTextDecoration}"></ng-container>
        </div>
    </div>
    <div class="row">
        <div class="col-md-3">
            <ng-container *ngTemplateOutlet="templateCampoCombo; context:{va:vaTextAlign}"></ng-container>
        </div>
        <div class="col-md-3">
            <ng-container *ngTemplateOutlet="templateCampoTexto; context:{va:vaTextIndent}"></ng-container>
        </div>
        <div class="col-md-6">
            <div class="row">
                <div class="form-group">
                    <label class="col-md-12 control-label">
                        <input type="checkbox" name="label" [(ngModel)]="vaPadding.checked" [disabled]="readonly">
                        Recuo do parágrafo
                    </label>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="recuoSuperior" class="control-label">Superior</label>
                            <input type="text" name="recuoSuperior" class="form-control"
                                [(ngModel)]="recuoSuperior" [required]="true" maxlength="6" [disabled]="readonly || !vaPadding.checked">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="recuoDireito" class="control-label">Direito</label>
                            <input type="text" name="recuoDireito" class="form-control"
                            [(ngModel)]="recuoDireito" [required]="true" maxlength="6" [disabled]="readonly || !vaPadding.checked">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="recuoInferior" class="control-label">Inferior</label>
                            <input type="text" name="recuoInferior" class="form-control"
                            [(ngModel)]="recuoInferior" [required]="true" maxlength="6" [disabled]="readonly || !vaPadding.checked">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="recuoEsquerdo" class="control-label">Esquerdo</label>
                            <input type="text" name="recuoEsquerdo" class="form-control"
                                [(ngModel)]="recuoEsquerdo" [required]="true" maxlength="6" [disabled]="readonly || !vaPadding.checked">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</fieldset>

<div class="row">
    <div class="col-md-12" style="text-align: right">
        <div class="form-group">
            <button type="button" class="btn btn-default" title="Fechar" (click)="cancelar()" *ngIf="modoTipoSegmento && readonly">
                Fechar
            </button>
            <button type="button" class="btn btn-default" title="Cancelar" (click)="cancelar()" *ngIf="modoTipoSegmento && !readonly">
                Cancelar
            </button>
            <button type="button" class="btn btn-primary" title="Salvar tipo de segmento" (click)="salvar()" *ngIf="modoTipoSegmento && !readonly">
                Salvar
            </button>
            <button type="button" class="btn btn-default" title="Cancelar" (click)="cancelar()" *ngIf="!modoTipoSegmento">
                Cancelar
            </button>
            <button type="button" class="btn btn-primary" title="Aplicar estilo no segmento" (click)="salvar()" *ngIf="!modoTipoSegmento">
                Aplicar estilo
            </button>
        </div>
    </div>
</div>

<ng-template #templateCampoTexto let-va="va">
    <div class="form-group">
        <label class="control-label">
            <input type="checkbox" name="label" [(ngModel)]="va.checked" [disabled]="readonly">
            {{ va.label }}
        </label>
        <input type="text" name="herdado" class="form-control" disabled [value]="va.herdado" *ngIf="!va.checked">
        <input type="text" name="setado" class="form-control" *ngIf="va.checked"
            [(ngModel)]="va.setado" [required]="true" maxlength="30" [disabled]="readonly">
    </div>
</ng-template>

<ng-template #templateCampoCombo let-va="va">
    <div class="form-group">
        <label class="control-label">
            <input type="checkbox" name="label" [(ngModel)]="va.checked" [disabled]="readonly">
                {{ va.label }}
        </label>
        <input type="text" name="herdado" class="form-control" disabled [value]="va.listaLabels[va.listaValores.indexOf(va.herdado)]" *ngIf="!va.checked">
        <suite-rfb-select name="combo" *ngIf="va.checked"
            [(ngModel)]="va.setado"
            [labels]="va.listaLabels"
            [values]="va.listaValores"
            [disabled]="readonly"
            [clearable]="false"
            [required]="true">
        </suite-rfb-select>
    </div>
</ng-template>
